import { createApiClient } from "@ametie/vue-muza-use";

import { useAuthStore } from "@/features/auth";

// In development, Vite proxy rewrites /api → backend, so we use /api as the base.
// In production, VITE_API_URL is the backend origin (no /api suffix) — we append it here
// so all REST calls consistently hit <origin>/api/<path>.
const BASE_URL = import.meta.env.VITE_API_URL_FOR_LOCAL_DEVELOPMENT
  ? "/api"
  : `${import.meta.env.VITE_API_URL ?? ""}/api`;

export const myAxios = createApiClient({
  baseURL: BASE_URL,
  withAuth: true,
  timeout: 2 * 60 * 1000,
  authOptions: {
    refreshUrl: "/auth/refresh",
    refreshWithCredentials: true,
    onTokenRefreshFailed: async () => {
      const authStore = useAuthStore();
      await authStore.logout();
    },
  },
});
